import React from 'react';
import { CTAButton } from './CTAButton';
export const Hero = () => {
  return <section className="w-full bg-blue-50 py-8 px-4" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-135">
          <div className="bg-red-600 text-white text-center py-3 font-bold text-xl md:text-2xl px-4" data-id="element-136">
            ATTENTION : Si Vos Pieds S'Engourdissent la Nuit, Lisez Ceci Avant
            Qu'il Ne Soit Trop Tard
          </div>
          <div className="p-6" data-id="element-137">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-138">
              Un diabétologue de Montréal révèle pourquoi ignorer ces signaux
              d'alarme pourrait vous mener tout droit vers l'amputation... et
              comment l'éviter naturellement
            </h1>
            <div className="text-gray-600 mb-4 italic" data-id="element-139">
              Par Dr. François Martineau, Diabétologue | Hôpital Notre-Dame,
              Montréal
              <br data-id="element-140" />
              Publié le 18 juin 2025 | Temps de lecture : 12 minutes
            </div>
            <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-141">
              <div className="md:w-1/2" data-id="element-142">
                <img src="https://images.unsplash.com/photo-1584515933487-779824d29309?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Personne souffrant d'engourdissement aux pieds" className="w-full h-auto rounded-md shadow-sm" data-id="element-143" />
              </div>
              <div className="md:w-1/2" data-id="element-144">
                <h2 className="text-xl font-bold text-blue-800 mb-3" data-id="element-145">
                  Un Réveil en Pleine Nuit Qui Change Tout
                </h2>
                <p className="text-gray-700 mb-4" data-id="element-146">
                  Il était 3h du matin quand Marcel Tremblay, 68 ans de
                  Longueuil, s'est réveillé en panique.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-147">
                  Ses pieds étaient complètement engourdis, comme morts. Il
                  s'est levé pour aller aux toilettes et s'est effondré. Sa
                  femme Denise a trouvé une plaie profonde sous son pied
                  droit... qu'il n'avait même pas sentie se former.
                </p>
                <p className="text-gray-700 font-bold" data-id="element-148">
                  Six semaines plus tard, Marcel perdait trois orteils.
                </p>
              </div>
            </div>
            <CTAButton showPrice={false} data-id="element-149" />
          </div>
        </div>
      </div>
    </section>;
};